import Template from '../../component/Template.js';
import Api from '../../component/Api';
import { useState } from 'react';
import React, {useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/*


*/


export default function AddPermission() {// CHECKING IF USER IS VALID
  
  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }


  const [permTitle, setPermTitle] = useState("");
  const [message, setMessage] = useState("");
  const [iscreateperm, setCreatePerm] = useState(false);//13/3/2024

  const { http } = Api();

  //role validation
  useEffect(() => {
    const access = async () => {

        const id = localStorage.getItem("id");
        try {
            const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });

            const permissions = response.data;
            permissions.forEach(permission => {

                if (permission.name === "create-permission") {
                  setCreatePerm(true);
                }


                
            });
        } catch (error) {
            setCreatePerm(false);
          
        }
    };
    access();
}, []);



  const validateForm = () => {

    if (!permTitle) {

      setMessage("Please enter a Permission Title");
      document.getElementById('perm').focus();
      return false;
    }
    return true;
  };

  const cancelForm = () => {
    navigate("/admin/permissions");
  };


  const saveNewPermission = (event) => {
    event.preventDefault();
    if (validateForm()) {
        const endpointaddpermission = `/Admin/create-permission/${permTitle}`;

    http.put(endpointaddpermission)
        .then(response => {
            if (response.data.status_code === 'MSG8') {

            setMessage("Permission Created Successfully");
            sessionStorage.setItem("message", "Permission Created Successfully");
            navigate("/admin/permissions");


            }
        })
        .catch(error => {
            console.error(error);
            
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                const errorMessage = error.response.data.message; // Extract error message from response
                toast.error(errorMessage);
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }

};



  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">                
                <div className="col-md-12">
                  <div className="card-header"> 
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Add Permission</h5>
                    </div>
                  </div>
                  <div className="card-body">
                  {message && (
                                                <div className="alert alert-danger mar2" role="alert">
                                                    <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                                                </div>
                                            )}
                    <div className="card-body pdg">
                      <div className="table-responsive">

                      {iscreateperm && (
                        <form className="form theme-form">
                          <div className="card-body custom-input">
                          
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Permission Title</label>
                                  <div className="col-sm-9">
                                    <input className="form-control input-air-primary" type="text" id="perm" name="perm" onChange={(e) => setPermTitle(e.target.value)} placeholder="Permission Titile" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveNewPermission}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>
                          
                        </form>
                      )}



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
